import styled from 'styled-components'

export const StyledEditTodo = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 24px;

  .edit-todo-common-field{
    flex: 1;
  }

  .edit-todo-footer{
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    align-items: center;
  }

  .todo-description{
    height: 100%;
  }

`

